import { useState } from 'react';
import { TableInput } from '../../../../components/common';
import { ModuleDataHandler } from '../helpers/handleReportCalc';

interface IProps {
  moduleData: any;
  isView: boolean;
  item: any;
  numberOfDay: any;

  setRender: React.Dispatch<React.SetStateAction<boolean>>;
  index: number;
}

const paymentType: any = {
  co_roll: 'Co. Roll',
  regular: 'Regular',
};

const category_type: any = {
  staff: 'Staff',
  contractual: 'Contractual',
  operator: 'Operator',
};

const TBodyRow = ({
  moduleData,
  isView,
  item,
  index,
  numberOfDay,
  setRender,
}: IProps) => {
  const dataHandler = new ModuleDataHandler(moduleData, numberOfDay);
  return (
    <>
      <tr>
        <td>{index + 1}</td>
        <td>
          {typeof item?.emp_id !== 'string' && item?.emp_id?.employee_name}
        </td>
        <td>{typeof item?.emp_id !== 'string' && item?.emp_id?.description}</td>
        <td>
          {typeof item?.emp_id !== 'string' &&
            paymentType[item?.emp_id?.payment_type]}
        </td>
        <td>
          <TableInput
            isView={isView}
            type="number"
            value={item.spl_allowance || null}
            onChange={(e) => {
              item.spl_allowance = Number(e.target.value);
              dataHandler.handleSalaryCalc(index);
              dataHandler.calculateTotal(
                'spl_allowance',
                'total_spl_allowance'
              );
              setRender((prev) => !prev);
            }}
          />
        </td>

        <td>
          <TableInput
            isView={isView}
            type="number"
            value={item.salary || null}
            onChange={(e) => {
              item.salary = Number(e.target.value);
              dataHandler.handleSalaryCalc(index);
              dataHandler.calculateTotal('salary', 'total_salary');
              setRender((prev) => !prev);
            }}
          />
        </td>

        <td>
          <TableInput
            isView={isView}
            type="number"
            value={item.duty || null}
            onChange={(e) => {
              item.duty = Number(e.target.value);
              dataHandler.handleSalaryCalc(index);
              dataHandler.calculateTotal('duty', 'total_duty');
              setRender((prev) => !prev);
            }}
          />
        </td>

        <td>
          <TableInput
            isView={isView}
            type="number"
            value={item.sun_ot || null}
            onChange={(e) => {
              item.sun_ot = Number(e.target.value);
              dataHandler.handleSalaryCalc(index);
              dataHandler.calculateTotal('sun_ot', 'total_sun_ot');
              setRender((prev) => !prev);
            }}
          />
        </td>

        <td>
          <TableInput
            isView={isView}
            type="number"
            value={item.total_1 || null}
            onChange={(e) => {
              item.total_1 = Number(e.target.value);
              dataHandler.handleSalaryCalc(index);
              dataHandler.calculateTotal('total_1', 'total_total_1');
              setRender((prev) => !prev);
            }}
          />
        </td>

        <td>
          <TableInput isView={true} type="number" value={item.ot || null} />
        </td>

        <td>
          <TableInput
            isView={true}
            type="number"
            value={item.duty_amt || null}
          />
        </td>

        <td>
          <TableInput isView={true} type="number" value={item.ot_amt || null} />
        </td>

        <td>
          <TableInput
            isView={true}
            type="number"
            value={item.total_2 || null}
          />
        </td>

        <td>
          <TableInput
            isView={isView}
            type="number"
            value={item.advance || null}
            onChange={(e) => {
              item.advance = Number(e.target.value);
              dataHandler.handleSalaryCalc(index);
              dataHandler.calculateTotal('advance', 'total_advance');
              setRender((prev) => !prev);
            }}
          />
        </td>

        <td>
          <TableInput
            isView={true}
            type="number"
            value={item.total_3 || null}
          />
        </td>

        <td>
          <TableInput
            isView={isView}
            type="number"
            value={item.tea || null}
            onChange={(e) => {
              item.tea = Number(e.target.value);
              dataHandler.handleSalaryCalc(index);
              dataHandler.calculateTotal('tea', 'total_tea');
              setRender((prev) => !prev);
            }}
          />
        </td>

        <td>
          <TableInput
            isView={isView}
            type="number"
            value={item.pf_esi || null}
            onChange={(e) => {
              item.pf_esi = Number(e.target.value);
              dataHandler.handleSalaryCalc(index);
              dataHandler.calculateTotal('pf_esi', 'total_pf_esi');
              setRender((prev) => !prev);
            }}
          />
        </td>

        <td>
          <TableInput
            isView={isView}
            type="number"
            value={item.cheque_payment || null}
            onChange={(e) => {
              item.cheque_payment = Number(e.target.value);
              dataHandler.handleSalaryCalc(index);
              dataHandler.calculateTotal(
                'cheque_payment',
                'total_cheque_payment'
              );
              setRender((prev) => !prev);
            }}
          />
        </td>

        <td>
          <TableInput
            isView={true}
            type="number"
            value={item.net_pay || null}
          />
        </td>

        <td>
          <TableInput
            isView={isView}
            type="number"
            value={item.previous_bal || null}
            onChange={(e) => {
              item.previous_bal = Number(e.target.value);
              dataHandler.handleSalaryCalc(index);
              dataHandler.calculateTotal('previous_bal', 'total_previous_bal');
              setRender((prev) => !prev);
            }}
          />
        </td>

        <td>
          <TableInput
            isView={true}
            type="number"
            value={item.cash_payable || null}
          />
        </td>

        <td>
          <TableInput
            isView={isView}
            type="number"
            value={item.cheque_amount || null}
            onChange={(e) => {
              item.cheque_amount = Number(e.target.value);
              dataHandler.handleSalaryCalc(index);
              dataHandler.calculateTotal(
                'cheque_amount',
                'total_cheque_amount'
              );
              setRender((prev) => !prev);
            }}
          />
        </td>

        <td>
          <TableInput
            isView={isView}
            type="text"
            value={item.remarks || null}
            onChange={(e) => {
              item.remarks = e.target.value;
              setRender((prev) => !prev);
            }}
          />
        </td>
      </tr>
    </>
  );
};

export default TBodyRow;
